import { config } from '@euler/config';

/** Where the studio is framed from, and the origin its messages must come from. */
export interface PosterStudioLocation {
  url: string;
  origin: string;
}

/** The page a host frames to open the whole studio (K09 in the posters repo). */
const kStudioPath = '/studio';

/**
 * The studio's entry page, with euler's theme for its first paint, or null when
 * this build has no usable `posterStudioUrl`.
 */
export function posterStudioLocation(): PosterStudioLocation | null {
  const base = parseUrl(config.posterStudioUrl);
  if (!base) return null;
  return {
    url: `${base.origin}${kStudioPath}?theme=light`,
    origin: base.origin,
  };
}

function parseUrl(value: string | undefined): URL | null {
  try {
    return new URL(value ?? '');
  } catch (error) {
    console.error('poster studio: posterStudioUrl is not configured:', error);
    return null;
  }
}
